<div class="h-full bg-grey-white_smoke dark:bg-contrast-black" ridangoAppTrapFocus>
    <div class="relative mb-4 bg-white px-3 py-6 text-center shadow dark:bg-contrast-black">
        <button
            class="absolute left-0 top-0 flex h-full items-center p-0 text-secondary md:hidden"
            [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
            [attr.title]="'LOCAL_BTN_BACK' | translate"
            (click)="cancel()"
            role="button"
            tabindex="0">
            <ion-icon
                class="h-8 w-8 p-3 dark:filter-yellow"
                [src]="(assetsPath$ | async) + '/img/ticket-details/back.svg'"></ion-icon>
        </button>
        <h1 class="text-base font-semibold">{{ 'TRAFFIC_ALERT_DETAILS' | translate }}</h1>
    </div>
    <div class="h-full bg-white dark:bg-contrast-black">
        <div class="p-4">
            <div class="flex flex-wrap gap-2">
                <div class="flex items-center">
                    <ng-container [ngSwitch]="disruptionMessage.severity">
                        <ion-icon
                            class="var-app-dark:text-black orb-app-dark:text-black text-red-alert_icon orb-app-light:text-red-alert_icon mr-2 text-2xl"
                            *ngSwitchCase="DisruptionMessageSeverity.CRITICAL"
                            title="{{ 'ALERT' | translate }}"
                            aria-label="{{ 'ALERT' | translate }}"
                            src="{{ assetsPath$ | async }}/img/journey-planner/icon-alert-circle.svg"></ion-icon>

                        <ion-icon
                            class="text-blue-alert_icon var-app-dark:text-black orb-app-dark:text-black mr-2 text-2xl"
                            *ngSwitchCase="DisruptionMessageSeverity.INFO"
                            title="{{ 'ALERT' | translate }}"
                            aria-label="{{ 'ALERT' | translate }}"
                            src="{{ assetsPath$ | async }}/img/journey-planner/icon-info-no-color.svg"></ion-icon>

                        <!-- WARNING (default) -->
                        <ion-icon
                            class="var-app-light:text-yellow-secondary mr-2 text-2xl"
                            *ngSwitchDefault
                            title="{{ 'ALERT' | translate }}"
                            aria-label="{{ 'ALERT' | translate }}"
                            src="{{ assetsPath$ | async }}/img/journey-planner/alert.svg"></ion-icon>
                    </ng-container>
                    <ion-label
                        class="text-base font-bold leading-5"
                        *ngIf="isBusDisruption && !isBusAndStopDisruption"
                        >{{ 'DISRUPTION_TYPE_LINES' | translate }}</ion-label
                    >
                    <ion-label
                        class="text-base font-bold leading-5"
                        *ngIf="isStopDisruption && !isBusAndStopDisruption"
                        >{{ messageStops }}</ion-label
                    >
                    <ion-label class="text-base font-bold leading-5" *ngIf="isBusAndStopDisruption">{{
                        'DISRUPTION_TYPE_LINES' | translate
                    }}</ion-label>
                </div>
                <div class="flex flex-wrap items-center gap-2" *ngIf="isBusDisruption || isBusAndStopDisruption">
                    <div
                        class="flex h-7 w-7 items-center justify-center overflow-hidden border-secondary bg-secondary font-sans text-xs font-bold text-white"
                        *ngFor="let line of messageLines"
                        [style.border-color]="(isContrast$ | async) ? null : line.icon?.color || leg?.icon?.color"
                        [style.background-color]="(isContrast$ | async) ? null : line.icon?.color || leg?.icon?.color"
                        [rwidgetShape]="line.icon?.shape"
                        [shapeText]="line.name"
                        [ngClass]="
                            (isContrast$ | async) ? 'dark:border-contrast-yellow dark:bg-contrast-black' : ''
                        "></div>
                </div>
                <div class="flex items-center" *ngIf="isBusAndStopDisruption && messageStops && messageStops !== ''">
                    <ion-label class="!whitespace-normal text-base font-bold leading-5">
                        {{ 'STOPS' | translate }}: {{ messageStops }}
                    </ion-label>
                </div>
            </div>
            <p class="pt-2 text-sm font-light leading-5 text-grey-dark dark:text-contrast-yellow">
                {{ disruptionMessage.activePeriodStart | momentDate: env.PERIOD_TICKET_DATE_FORMAT : env.TIMEZONE }}
                -
                {{ disruptionMessage.activePeriodEnd | momentDate: env.PERIOD_TICKET_DATE_FORMAT : env.TIMEZONE }}
            </p>
            <p class="pt-2 text-sm font-light leading-5">{{ headerText }}</p>
            <div class="border-b border-solid border-black border-opacity-10 pt-3"></div>
            <p class="pt-2 text-sm font-light leading-5">{{ descriptionText }}</p>
        </div>

        <div class="mb-2 px-4" *ngFor="let url of processedUrls">
            <ng-container [ngSwitch]="url.type">
                <img *ngSwitchCase="'image'" [src]="url.src" [alt]="url.alt" (click)="openImageFullScreen(url)" />
                <a
                    class="flex h-14 items-center justify-center gap-2 text-sm font-semibold leading-5 text-secondary hover:no-underline"
                    *ngSwitchCase="'url'"
                    [href]="url.src"
                    [attr.aria-label]="'READ_MORE' | translate"
                    target="_blank">
                    {{ 'READ_MORE' | translate }}
                    <ion-icon class="dark:filter-yellow" name="arrow-forward-outline" aria-hidden="true"></ion-icon>
                </a>
            </ng-container>
        </div>
        <div class="mt-4 px-4" *ngIf="disruptionMessage?.lastModified">
            <div
                class="border-t border-solid border-black border-opacity-10 pt-2 text-xs font-light leading-5 text-grey-dark dark:text-contrast-yellow">
                {{
                    (disruptionMessage?.versionNumber > 1
                        ? 'TRAFFIC_INFORMATION_UPDATED_DATE_LABEL'
                        : 'TRAFFIC_INFORMATION_PUBLISHED_DATE_LABEL'
                    ) | translate
                }}:
                {{ disruptionMessage.lastModified | momentDate: env.PERIOD_TICKET_DATE_FORMAT : env.TIMEZONE }}
            </div>
        </div>
    </div>
</div>

<ion-modal
    class="disruption-message-image_modal"
    [isOpen]="!!selectedImageConfig"
    (didDismiss)="closeSelectedImageModal()">
    <ng-template>
        <ion-slides [options]="{ zoom: true, allowSlideNext: false, allowSlidePrev: false }" pager="true">
            <ion-slide>
                <div class="swiper-zoom-container">
                    <!--                    selectedImageConfig is used with '?' operator because ion-modal works through isOpen, and doesn't work with ngIf*/@for-->
                    <img [src]="selectedImageConfig?.src" [alt]="selectedImageConfig?.alt" />
                </div>
            </ion-slide>
        </ion-slides>
    </ng-template>
</ion-modal>
